export default {
  sections: {
    asap_orders: {
      title: 'Pedidos inmediatos',
      fields: {
        has_live_orders: {
          label: 'Pedidos en vivo',
          tooltip: 'Active esta opción solo cuando el restaurante esté listo para empezar a aceptar pedidos',
        },
        has_asap_orders: {
          label: '¿Permite a sus clientes realizar pedidos inmediatos?',
          tooltip: '*Los pedidos inmediatos se basan en su tiempo de preparación',
        },
      },
    },
    scheduled_orders: {
      title: 'Pedidos programados',
      fields: {
        has_scheduled_orders: {
          label: '¿Permite a sus clientes hacer pedidos con antelación para horarios específicos?',
        },
        has_pre_order: {
          label: '¿Permite a sus clientes hacer pedidos con más de un día de antelación?',
        },
        max_pre_order_days: {
          label: 'Máximo de días de antelación para pedir',
          placeholder: '14',
        },
        has_scheduled_order_reminders: {
          label: 'Notificaciones de recordatorio de pedidos programados',
        },
        scheduled_orders_time_slot_interval: {
          label: 'Franjas horarias en minutos',
          option: 'Franja de {{value}} minutos',
        },
        has_scheduled_orders_time_slot_order_limit: {
          label: 'Agregar cantidad máxima de pedidos por franja horaria',
        },
        scheduled_orders_time_slot_order_limit: {
          label: 'Cantidad máxima de pedidos por franja horaria',
          placeholder: '5',
        },
        scheduled_order_option_title: {
          label: 'Título de la opción de programar para después',
          placeholder: 'Programar para después',
        },
      },
    },
    other: {
      title: 'Otros',
      fields: {
        order_approval_time_step: {
          label: 'Aumentar / reducir tiempo de pedido confirmado',
          option: '{{value}} min',
        },
        order_confirmation_time_extra_minutes: {
          label: 'Agregar minutos extra al tiempo confirmado',
          option: '{{value}} min',
        },
      },
    },
  },
  buttons: {
    save: 'Guardar',
  },
  feedback: {
    restaurant_suspended: {
      title: 'Este restaurante fue suspendido',
      description:
        'Para volver a estar en línea, vaya a la <a>página de suscripción</a> y reactive el restaurante; luego podrá activar los pedidos en vivo en esta página.',
    },
  },
  toasts: {
    at_least_one_order_method_required:
      'Al menos 1 método de pedido (programado o inmediato) debe estar activado. No se pueden desactivar ambos.',
  },
};
